import React from 'react'

const MenuTrigger = () => (
  <svg width="20" height="16" xmlns="http://www.w3.org/2000/svg"><g className="fill-current" fillRule="evenodd"><rect width="20" height="2" rx="1"/><rect x="5" y="7" width="15" height="2" rx="1"/><rect x="10" y="14" width="10" height="2" rx="1"/></g></svg>
)

export default MenuTrigger
